var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriodontics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-686 -1500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,2A26,26,0,1,1,1,28,26,26,0,0,1,27,2Z",
    transform: "translate(715 1498)",
    fill: "#bee3f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7,63a7.608,7.608,0,0,1-7.6-6.99,7.288,7.288,0,0,1-2.96-2.712l0,0c-.845-1.173-1.155-1.49-1.726-1.49s-.882.317-1.726,1.489c-.888,1.231-2.229,3.092-4.876,3.092s-3.988-1.859-4.875-3.089C15.085,52.12,14.775,51.8,14.2,51.8s-.881.317-1.725,1.489c-.888,1.231-2.229,3.092-4.876,3.092s-3.987-1.859-4.874-3.089C1.881,52.12,1.571,51.8,1,51.8V47.984c2.647,0,3.988,1.86,4.875,3.091.845,1.172,1.155,1.49,1.726,1.49s.882-.317,1.725-1.489c.888-1.231,2.229-3.092,4.876-3.092s3.989,1.86,4.876,3.091c.844,1.172,1.154,1.49,1.726,1.49s.881-.317,1.725-1.489c.888-1.231,2.229-3.092,4.877-3.092,2.3,0,3.6,1.349,4.668,2.806V23.643l2.152-4.615H29.279V1H50.947l9.225,4.4V8.01H67v3.818H60.172V14.1L51,19.029H44.833l2.493,4.55v5.446h2.49v3.817h-2.49v2.673h2.49v3.818h-2.49V55.473A7.585,7.585,0,0,1,39.7,63ZM35.943,25.97v29.5a3.758,3.758,0,0,0,7.515,0V25.97Zm2.542-6.943-1.457,3.125h5.121l-1.712-3.125ZM33.146,4.818V15.21H50.012L56.3,11.828V7.8L50.062,4.818Z",
    transform: "translate(685 1517)",
    fill: "#4299e1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodontics);
export default __webpack_public_path__ + "static/media/periodontics.f815b9f3b70e1e6e33dec972a1377428.svg";
export { ForwardRef as ReactComponent };